import { DashboardLayout } from "layouts/dashboard.layout";
import { AppWelcomeCard } from "./components/welcome-card.component";
import { AppSalesHistory } from "./components/sales-history.component";
import { AppStatisticsInfo } from "./components/statistis-info.component";
import { dashboardPageData } from "constants/dashboard-page.data";
import VuiTypography from "components/VuiTypography";
import { useEffect, useState } from "react";
import { getSalesIbCount } from "services/challenge-orders/challenge-orders.services";
import { getIbFullInfo } from "services/customers/customers.services";
import { getUser } from "services/auth/auth.service";
import { Redirect } from "react-router-dom";

export function Dashboard() {
  const [ibSales, setIbSales] = useState([]);
  const [fullInfoIb, setFullInfoIb] = useState();

  const session = getUser();

  //TODO types en constantes
  if (session && session.ibType === 100) {
    return <Redirect to="/dashboard/associate-reports" />;
  }

  const getCurrentDate = () => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Date().toLocaleString("es-ES", options);
  };

  const fetchIbSales = async () => {
    const { success, data } = await getSalesIbCount({});
    if (success) setIbSales(data);
  };

  const fetchFullInfoIb = async () => {
    const { success, data } = await getIbFullInfo();
    if (success) setFullInfoIb(data.item);
  };

  useEffect(() => {
    fetchFullInfoIb();
    fetchIbSales();
  }, []);

  return (
    <DashboardLayout>
      <VuiTypography
        color="white"
        sx={{
          marginLeft: "17px",
          marginBottom: "24px",
          marginTop: "12px",
          fontSize: "16px",
          lineHeight: "16px",
          fontWeight: "400",
          letterSpacing: "1px",
        }}
      >
        {getCurrentDate()}
      </VuiTypography>
      <AppWelcomeCard pageData={dashboardPageData} fullInfoIb={fullInfoIb} />
      <AppStatisticsInfo
        pageData={dashboardPageData}
        fullInfoIb={fullInfoIb}
        ibSalesCounter={ibSales.reduce((total, { value }) => total + value, 0)}
      />
      <AppSalesHistory pageData={dashboardPageData} ibSales={ibSales} />
    </DashboardLayout>
  );
}
